
import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import { PopupModule } from '~common-store/modules/popup';



@Component({})
export default class PopupRollout extends Mixins(PopupMixin) {
    isReleasing = false;

    async releaseProgressiveRollout() {
        if (this.isReleasing) return;
        this.isReleasing = true;
        const flag = RemoteFeatureFlagsModule.currentRolloutFlag;
        const currentRolloutValue = RemoteFeatureFlagsModule.currentRolloutValue;
        if(!flag) return;
        try {
            await RemoteFeatureFlagsModule.releaseProgressiveRolloutFlag({
                flag: flag,
                progressive: currentRolloutValue,
            });

            this.$emit('updateFlagValues', {id: flag.id, values: [
                { key: 'released', value: true },
                { key: 'progress', value: currentRolloutValue }
            ]});

            PopupModule.setPopupInactive();
        } finally {
            this.isReleasing = false;
        }
    }

    updateRolloutValue(value: number): void {
        RemoteFeatureFlagsModule.setCurrentRolloutValue(value);
    }

    get featureFlags() {
        return RemoteFeatureFlagsModule.availableFlags;
    }

    get currentRolloutValue(): number {
        return RemoteFeatureFlagsModule.currentRolloutValue;
    }

    get currentRolloutFlagName(): string {
        return RemoteFeatureFlagsModule.currentRolloutFlag?.name || '';
    }
}
